import { gql } from 'graphql-tag'

// Canonical consumer fragment — from CMA (CWA does not define a ConsumerFields fragment)
export const consumerFields = gql`
  fragment ConsumerFields on Consumer {
    consumerId
    email
    name
    phoneNumber
    agreedToTermsAndConditions
    latestTermsVersionAgreedTo
    submittedAppReviewDate
    notificationPreferences {
      channel
      optedOutViaCarrier
      invalidSmsDestination
    }
  }
`
